import { render, staticRenderFns } from "./AmountAccountedFor.vue?vue&type=template&id=02130148&"
import script from "./AmountAccountedFor.vue?vue&type=script&lang=js&"
export * from "./AmountAccountedFor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports